import React from 'react'
import Image from '../../../images/sellerpolicies/2.png'

const Advertisements_on_the_service = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Advertisements on the Service</h2>
            <p>KAAY or its selected business partners may provide advertising to you through the Service or by other methods such as email or any selected social media. This advertising may be based on your User Content or other information available through the Service. When delivering advertising we will only use information that identifies you as set out in our Privacy Policy.</p>
        </div>
      </div>
    </div>
  )
}

export default Advertisements_on_the_service
